import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {Banner} from "./dtos/banner";

@Injectable({
    providedIn: 'root'
})
export abstract class BannerRemote {
    /**
     * Get the home banner data to be displayed on the top of the home page.
     * @returns {Observable<Banner | null>} - Banner data or null if there is no banner.
     */
    public abstract getHomeBanner(): Observable<Banner | null>;

    /**
     * Get the top banner data to be displayed on the top of the top bar.
     * @returns {Observable<Banner | null>} - Banner data or null if there is no banner.
     */
    public abstract getTopBanner(): Observable<Banner | null>;
}
